import { c as _c } from "react/compiler-runtime";
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { useMediaState } from '../../../hooks/use-media-state';
import { Content } from '../modal-content';
import { Footer } from '../modal-footer';
import { SlidesHeader } from './slides-header';
type SlidesProps = {
  activeContent: string | undefined;
  onClose: VoidFunction;
  slides: Array<{
    name: string;
    title: ReactNode;
    content?: ReactNode;
    children?: ReactNode;
    footer?: ReactNode;
    order?: number;
    onBackClick?: VoidFunction;
  }>;
};
const variants = {
  enter: (slideDirection: string) => ({
    x: slideDirection === 'backward' ? '-100%' : '100%'
  }),
  center: {
    x: 0
  },
  exit: (slideDirection: string) => ({
    x: slideDirection === 'backward' ? '100%' : '-100%'
  })
};
export const Slides = t0 => {
  const $ = _c(24);
  const {
    activeContent,
    onClose,
    slides
  } = t0;
  const isMobile = useMediaState("mobile");
  let t1;
  if ($[0] !== activeContent) {
    t1 = slide => slide.name === activeContent;
    $[0] = activeContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const index = slides.findIndex(t1);
  const slide_0 = slides[index];
  const order = slide_0.order ?? index;
  const [lastOrder, setLastOrder] = useState(order);
  const [slideDirection, setSlideDirection] = useState("forward");
  if (lastOrder !== order) {
    setLastOrder(order);
    setSlideDirection(lastOrder >= order ? "backward" : "forward");
  }
  const mode = isMobile ? "sync" : "wait";
  const t2 = index > 0;
  let t3;
  if ($[2] !== onClose || $[3] !== slide_0.onBackClick || $[4] !== slide_0.title || $[5] !== t2) {
    t3 = <SlidesHeader title={slide_0.title} onClose={onClose} animate={t2} onBackClick={slide_0.onBackClick} />;
    $[2] = onClose;
    $[3] = slide_0.onBackClick;
    $[4] = slide_0.title;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = isMobile ? variants : undefined;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 0.2,
      delay: 0.1
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== slide_0.children || $[9] !== slide_0.content || $[10] !== slide_0.footer) {
    t6 = slide_0.children || <Content renderFooter={slide_0.footer ? () => <Footer>{slide_0.footer}</Footer> : undefined}>{slide_0.content}</Content>;
    $[8] = slide_0.children;
    $[9] = slide_0.content;
    $[10] = slide_0.footer;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== slideDirection || $[13] !== slide_0.name || $[14] !== t4 || $[15] !== t6) {
    t7 = <m.div key={slide_0.name} className="absolute inset-0 sm:static sm:max-h-full" variants={t4} custom={slideDirection} initial="enter" animate="center" exit="exit" transition={t5}>{t6}</m.div>;
    $[12] = slideDirection;
    $[13] = slide_0.name;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== mode || $[18] !== slideDirection || $[19] !== t7) {
    t8 = <div className="relative h-full sm:flex sm:min-h-0 sm:flex-col"><AnimatePresence initial={false} custom={slideDirection} mode={mode}>{t7}</AnimatePresence></div>;
    $[17] = mode;
    $[18] = slideDirection;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t8) {
    t9 = <>{t3}{t8}</>;
    $[21] = t3;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};